Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + parseInt(days));
  return date;
};
export function getTotalDays(date1, date2) {
  //Get 1 day in milliseconds
  var one_day = 1000 * 60 * 60 * 24; // Convert both dates to milliseconds
  var date1_ms = date1.getTime();
  var date2_ms = date2.addDays(1).getTime(); // Calculate the difference in milliseconds
  var difference_ms = date2_ms - date1_ms; // Convert back to days and return
  return Math.round(difference_ms / one_day);
}
function monthDiff(dt1, dt2, cachTinhLai) {
  if (cachTinhLai == 1) {
    dt1.setDate(dt1.getDate() + 1);
  }
  var dateNext = dt1;
  var countMonth = 0;
  while (dateNext <= dt2) {
    countMonth += 1;
    dateNext.setMonth(dateNext.getMonth() + 1);
  }
  return countMonth;
}
export function tinhNgayTraGocv3(
  soLanTra,
  tongSoNgayVay,
  counTypePaid,
  ngayVay,
  TypePaid,
  cachTinhLai,
  isNgayTraGoc,
  NgayTraGoc,
  isTongNgayTraLai = false,
  isEditAll
) {
  if (!NgayTraGoc && isEditAll) {
    let date = new Date(
      ngayVay.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
    );
    if (tongSoNgayVay && !soLanTra) {
      tongSoNgayVay = parseInt(tongSoNgayVay);
      if (TypePaid === 2 || TypePaid === 3)
        soLanTra = Math.ceil(
          parseFloat(tongSoNgayVay) / parseFloat(counTypePaid * 30)
        );
      else if (TypePaid === 4) {
        soLanTra = Math.ceil(
          parseFloat(tongSoNgayVay) / parseFloat(counTypePaid * 7)
        );
      }
      else
        soLanTra = Math.ceil(
          parseFloat(tongSoNgayVay) / parseFloat(counTypePaid)
        );
    } else if (counTypePaid && soLanTra && !tongSoNgayVay) {
      // if (TypePaid === 4) {
      //   tongSoNgayVay = parseInt(counTypePaid * 7) * parseInt(soLanTra);
      // }
      // else {
      tongSoNgayVay = parseInt(counTypePaid) * parseInt(soLanTra);
      // }

    }
    NgayTraGoc = date.addDays(tongSoNgayVay - 1);
    if (NgayTraGoc < date) {
      NgayTraGoc = date;
    }

    if (TypePaid === 2) {
      let currentDate = date.getDate();
      // Set to day 1 to avoid forward
      date.setDate(1);
      // Increase month
      date.setMonth(date.getMonth() + soLanTra * counTypePaid);
      // Get max # of days in this new month
      let daysInMonth = new Date(
        date.getYear(),
        date.getMonth() + 1,
        0
      ).getDate();
      // Set the date to the minimum of current date of days in month
      date.setDate(Math.min(currentDate, daysInMonth));
      NgayTraGoc = date.addDays(-1);
    }
    if (TypePaid === 3) {
      let currentDate = date.getDate();
      // Set to day 1 to avoid forward
      date.setDate(1);
      // Increase month
      date.setMonth(date.getMonth() + soLanTra * counTypePaid);
      // Get max # of days in this new month
      var daysInMonth = new Date(
        date.getYear(),
        date.getMonth() + 1,
        0
      ).getDate();
      // Set the date to the minimum of current date of days in month
      date.setDate(Math.min(currentDate, daysInMonth));
      NgayTraGoc = date.addDays(-1);
    }
    if (TypePaid === 4) {
      NgayTraGoc = date.addDays(tongSoNgayVay * 7);
      NgayTraGoc = NgayTraGoc.addDays(-1);
    }

    var dd = NgayTraGoc.getDate();
    var mm = NgayTraGoc.getMonth() + 1; //January is 0!

    var yyyy = NgayTraGoc.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    var formatDate = dd + '/' + mm + '/' + yyyy;
    if (tongSoNgayVay > 0) {
      NgayTraGoc = formatDate;
    } else {
      NgayTraGoc = '';
      return '';
    }
    return {
      TongSoNgayVay: tongSoNgayVay,
      NgayTraGoc,
      SoLanTra: soLanTra,
    };
  } else {
    counTypePaid = counTypePaid ? counTypePaid : 1;
    var dateNgayVay = new Date(
      ngayVay.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
    );
    var dateNgayTra = new Date(
      NgayTraGoc.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
    );
    tongSoNgayVay = getTotalDays(dateNgayVay, dateNgayTra);
    if (cachTinhLai === 1) {
      tongSoNgayVay = tongSoNgayVay - 1;
    }
    if (TypePaid === 2) {
      tongSoNgayVay = monthDiff(dateNgayVay, dateNgayTra, cachTinhLai);
    }
    if (TypePaid === 3) {
      tongSoNgayVay = monthDiff(dateNgayVay, dateNgayTra, cachTinhLai);
    }
    if (TypePaid === 4) {
      tongSoNgayVay = tongSoNgayVay - 1;
    }
    if (tongSoNgayVay < 1) {
      tongSoNgayVay = 1;
    }

    soLanTra = Math.ceil(tongSoNgayVay / counTypePaid);
    if (soLanTra < 1) {
      soLanTra = 1;
    }
    return {
      TongSoNgayVay: tongSoNgayVay,
      NgayTraGoc,
      SoLanTra: soLanTra,
    };
  }
}
